import classNames from 'classnames';
import { useCallback } from 'react';
import { Heading, List } from 'yoso';
import { BaseCard } from '~/components/Card';
import { myCitizenItemsUrl } from '~/components/Dosi/Dosi.hooks';
import { useEmbeddedViewer } from '~/components/Embedded/Embedded.hooks';
import { T, Translation } from '~/components/I18n';
import hatCitizen from '~/components/Icon/Citizen/toneupCitizen.png';
import info from '~/components/Icon/info.png';
import yellowCat from '~/components/Icon/yellowCat.png';
import { useNftCount } from '~/components/Membership/Membership.hooks';
import { Link } from '~/components/Route/Link';
import { format } from '~/components/Util/number';
import styles from './AssetStatusList.module.scss';

export type AssetStatusListProps = {
  className?: string;
};

export const AssetStatusList = ({ className }: AssetStatusListProps) => {
  const { open } = useEmbeddedViewer();
  const onMyItemClick = useCallback(() => {
    open(myCitizenItemsUrl);
  }, [open]);

  const {
    data: { citizen, additional },
    isInitialLoading: isNftCountInitialLoading,
  } = useNftCount();

  const isInitialLoading = isNftCountInitialLoading;

  return (
    <List className={classNames(styles.root, { [styles.loading]: isInitialLoading }, className)}>
      <li>
        <BaseCard
          color="muted"
          className={styles.item}
          onClick={onMyItemClick}
          size="large"
          data-event="click"
          data-event-target="dashboard_myitems_citizen_btn">
          <div className={styles.itemHeader}>
            <Heading level={5} className={styles.itemTitle}>
              Citizen
            </Heading>
            <p className={styles.itemDescription}>
              <Translation
                name="citizen_unit"
                options={{
                  0: format(citizen?.count, { zeroAsEmpty: true }),
                  count: citizen?.count,
                }}
              />
            </p>
          </div>
          <img className={styles.itemImage} src={hatCitizen} alt="citizen" width={65} height={65} />
        </BaseCard>
      </li>
      <li>
        <BaseCard
          color="muted"
          className={styles.item}
          onClick={onMyItemClick}
          size="large"
          data-event="click"
          data-event-target="dashboard_myitems_friends_btn">
          <div className={styles.itemHeader}>
            <Heading level={5} className={styles.itemTitle}>
              Friends
            </Heading>
            <p className={styles.itemDescription}>
              <Translation
                name="citizen_unit"
                options={{
                  0: format(additional?.friendsCount, { zeroAsEmpty: true }),
                  count: additional?.friendsCount,
                }}
              />
            </p>
          </div>
          <img className={styles.itemImage} src={yellowCat} alt="friends" width={65} height={65} />
        </BaseCard>
      </li>
      <li>
        <Link
          to="/challenge/guide"
          data-event="click"
          data-event-target="dashboard_challenge_guide_btn">
          <BaseCard color="muted" className={styles.item} size="large">
            <div className={styles.itemHeader}>
              <Heading level={5} className={styles.itemTitle}>
                <T name="citizen_quick_challenge_howto" />
              </Heading>
            </div>
            <img
              src={info}
              alt="challenge guide"
              className={styles.itemImage}
              width={65}
              height={65}
            />
          </BaseCard>
        </Link>
      </li>
    </List>
  );
};
